/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Alert, Button } from 'react-bootstrap';
import { t, translate } from 'react-switch-lang';
import { Link } from 'react-router-dom';
import './contactusform.scss';
import './ContactUsPayments.scss';
import { useSelector } from 'react-redux';
import { validateBody, validateName } from './Validation';
import { invalidFormAlert } from '../../../helperFunctions/Accessibility';
import RelevantFAQ from './RelevantFAQ';
import ContactFormHeader from './ContactFormHeader';
import ReplaceTextWithElement from '../../../helperFunctions/ReplaceTextWithElement';
import useRelevantFAQSearch from '../../../helperFunctions/useRelevantFAQSearch';
import useContactFormSubmit from '../../../helperFunctions/useContactFormSubmit';
import {
  MailcheckEmailField,
  ContactRadioField,
  TextAreaField,
  TextField,
} from '../../../components/FormFields/FormFields';
import ContactReCaptcha from '../../../components/ContactReCaptcha';
import { getContactFormStyle } from '../../../configurations/Brands';
import {
  events,
  trackGoogleAnalyticsEvent,
} from '../../../helperFunctions/GoogleAnalytics';

function ContactUsPayments({ widgetMode }) {
  const { brand, lang } = useSelector((state) => state);
  const { handleTextareaChange, searchResults } = useRelevantFAQSearch({ brand, lang });
  const {
    dismissError,
    error,
    errorMessageRef,
    reCaptchaRef,
    showReCaptchaError,
    showError,
    submitted,
    submitContactRequest,
    successMessageRef,
  } = useContactFormSubmit();

  const isMobile = (window.location.href.includes('mobileapp') ? '?mobileapp' : '');

  useEffect(() => {
    trackGoogleAnalyticsEvent(events.CONTACT_FORM_VIEW, {
      brand,
      language: lang,
    });
  }, [brand, lang]);

  function validateContactForm(values) {
    const errors = {};
    const nameError = validateName(values.name || '');
    const descriptionError = validateBody(values.description || '');

    if (nameError) errors.name = nameError;
    if (!values.paymentMethod) errors.paymentMethod = t('Validation_Required');
    if (descriptionError) errors.description = descriptionError;

    return errors;
  }

  async function sendAPI(values) {
    const data = {
      Brand: 'PSI Payments',
      BrandID: 'Payments',
      CustomerEmail: values.customerEmail,
      Body: values.description,
      PaymentOption: values.paymentMethod,
      Language: lang,
      Name: values.name,
    };

    return submitContactRequest(data);
  }

  useEffect(() => {
    if (widgetMode) {
      document.getElementById('desktop-contact-us').style.padding = '0px';
    }
  }, []);

  return (
    <>
      {showError && (
        <Alert
          ref={errorMessageRef}
          variant="danger"
          id="error_message"
          className="mt-3"
          onClose={dismissError}
          dismissible
        >
          <p style={{ marginBottom: 0 }}>{error}</p>
        </Alert>
      )}
      {submitted && (
        <div
          id="successMessage"
          ref={successMessageRef}
          style={{ display: 'block', visibility: 'visible' }}
        >
          <h1>{t('ContactForm_Submitted')}</h1>
          <Link to={(widgetMode) ? `/widget/${brand}/${lang}${isMobile}` : `/${brand}/${lang}/categories`}>
            <Button className={`error-go-home-btn ${brand}-button`}>{t('ReturnHome_Btn')}</Button>
          </Link>
        </div>
      )}
      {!submitted && (
        <div
          id="desktop-contact-us"
          className={widgetMode && 'widget-mode-form'}
          style={getContactFormStyle('payments')}
        >
          <div id="skip-link-content">
            <ContactFormHeader brand="payments" lang={lang} widgetMode={widgetMode} />
            <p className="contact-label-suggestion">{t('ContactForm_Fields_Required')}</p>
            <FinalForm
              onSubmit={sendAPI}
              validate={validateContactForm}
              render={({
                handleSubmit,
                invalid,
                errors,
                submitting,
                submitFailed,
                touched,
              }) => {
                const paymentMethodError = errors.paymentMethod;
                const showPaymentMethodError = (
                  touched?.paymentMethod || submitFailed
                ) && paymentMethodError;

                return (
                  <form
                    onSubmit={(event) => {
                      invalidFormAlert(invalid, errors);
                      handleSubmit(event);
                    }}
                    noValidate
                  >
                    <div className="row">
                      <MailcheckEmailField
                        className="col-12 col-md-6"
                        id="ContactForm_General_Email_"
                        name="customerEmail"
                        label={t('ContactForm_General_Email_Label')}
                        formatText={t('ContactForm_General_Email_Help')}
                      />
                    </div>

                    <div className="row">
                      <TextField
                        className="col-12 col-md-6"
                        id="ContactForm_General_Name_"
                        name="name"
                        label={t('ContactForm_Name')}
                      />
                    </div>
                    <fieldset className="payments-radio form-field">
                      <legend
                        id="paymentMethodLabel"
                        className={`field-label ${showPaymentMethodError ? 'is-invalid' : ''}`}
                      >
                        {t('ContactForm_Which_Payment_Option')}
                      </legend>
                      <div id="paymentsOptionsBtnGroup" className="radio-container">
                        <ContactRadioField
                          name="paymentMethod"
                          value="eTransfer"
                          content={(
                            <ReplaceTextWithElement
                              text={t('ContactForm_PaymentOption_eTransfer')}
                              replaceWith={<i>Interac</i>}
                              replaceKey="Interac"
                            />
                        )}
                        />
                        <ContactRadioField
                          name="paymentMethod"
                          value="In Person at Canada Post"
                          content={(
                            <>
                              {t('In-Person_at_Canada_Post')}
                            </>
                        )}
                        />
                      </div>
                      {showPaymentMethodError && (
                      <span className="errorMessage errorMessageBlock">{paymentMethodError}</span>
                      )}
                    </fieldset>

                    <div className="row">
                      <TextAreaField
                        className="col-12"
                        id="ContactForm_General_Body_"
                        name="description"
                        label={t('ContactForm_General_Body_Label')}
                        onChange={handleTextareaChange}
                      >
                        <div className="sensitive-information-disclaimer">
                          {t('Sensitive_Information_Disclaimer')}
                        </div>
                      </TextAreaField>
                    </div>

                    <RelevantFAQ searchResults={searchResults} brand={brand} lang={lang} />
                    <Button
                      id="submit-button"
                      className="paysimply-button"
                      type="submit"
                      disabled={submitting}
                      size="lg"
                      style={{ backgroundColor: '#2B4E7B' }}
                    >
                      {submitting ? t('ContactForm_Submitting') : t('ContactForm_Submit_button')}
                    </Button>
                    <ContactReCaptcha ref={reCaptchaRef} onErrored={showReCaptchaError} />
                  </form>
                );
              }}
            />
            <Alert className="mt-3 email-banner" show={process.env.REACT_APP_ENV === 'dev'}>
              On the test system, contact form emails will be sent to
              <strong> psidevstar@gmail.com</strong>
            </Alert>
          </div>
        </div>
      )}
    </>
  );
}

export default translate(ContactUsPayments);
